let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jJyiN")).then(() => parcelRequire('gBuYk'));